$(document).on('mapsLoaded', function() {

    window.Marker = function(options) {
        this.options = $.extend({}, options);
        this.div = $('<div class="marker"/>');
        this.infobox = $('<div class="infobox"/>').appendTo(this.div);
        let dot = $('<div class="dot"/>').appendTo(this.div);
        this.div.on('mouseenter', this.onMouseEnter.bind(this));
        this.div.on('click', this.onClick.bind(this));
        if (this.options.position) this.setPosition(this.options.position);
        if (this.options.angle) {
            this.div.addClass('with-angle');
            dot.css('transform', 'rotate(' + (this.options.angle + 225) + 'deg)');
        }
        if (this.options.yearMin) {
            this.options.year = this.options.yearMin;
            switch (this.options.accuracy) {
                case 2:
                    this.options.yearMin = this.options.yearMin - 9;
                    this.options.yearMax = this.options.yearMin + 9;
                    break;
                case 3:
                    this.options.yearMax = this.options.yearMin;
                    this.options.yearMin = 0;
                    break;
                case 4:
                    this.options.yearMax = 3000;
                    break;
                default:
                    this.options.yearMax = this.options.yearMin;
            }
        }
    }

    Marker.prototype = new google.maps.OverlayView();

    Marker.prototype.draw = function() {
        var point = this.getProjection().fromLatLngToDivPixel(this.getPosition());
        if (point) {
            this.div[0].style.left = point.x + 'px';
            this.div[0].style.top = point.y + 'px';
        }
    };

    Marker.prototype.remove = function() {
        this.div.remove();
    };

    Marker.prototype.activate = function () {
        if (!this.isActive()) {
            if (Marker.activeMarker) Marker.activeMarker.deactivate();
            Marker.activeMarker = this;
            this.div.addClass('selected');
        }
    }

    Marker.prototype.deactivate = function () {
        if (this.isActive()) {
            delete Marker.activeMarker;
            this.div.removeClass('selected');
        }
    }

    Marker.prototype.hover = function (hover) {
        if (hover === false) {
            if (this.isHovered()) {
                delete Marker.hoverMarker;
                this.div.removeClass('hover');
            }
        } else if (!this.isHovered()) {
            if (Marker.hoverMarker) Marker.hoverMarker.hover(false);
            this.onMouseEnter();
            Marker.hoverMarker = this;
            this.div.addClass('hover');
        }
    }

    Marker.prototype.isActive = function () {
        return this === Marker.activeMarker;
    }

    Marker.prototype.isHovered = function () {
        return this === Marker.hoverMarker;
    }

    Marker.prototype.getPosition = function() {
        if (!this.options.position instanceof google.maps.LatLng) {
            this.options.position = new google.maps.LatLng(this.options.position.lat, this.options.position.lng);
        }
        return this.options.position;
    };

    Marker.prototype.setPosition = function(position) {
        if (position instanceof google.maps.LatLng) this.options.position = position;
        else this.options.position = new google.maps.LatLng(position.lat, position.lng);
    };

    Marker.prototype.setFiltered = function(filtered) {
        this.div.toggleClass('filtered', filtered);
    };

    Marker.prototype.isFiltered = function() {
        return this.div.hasClass('filtered');
    }

    Marker.prototype.isHighlighted = function() {
        return this.div.hasClass('highlighted');
    }

    Marker.prototype.filter = function (yearMin, yearMax, types, highlightTime, onlyComparable) {
        let valid = true;
        if (yearMin && this.options.yearMin) {
            valid = valid && (this.options.yearMin <= yearMax && this.options.yearMax >= yearMin);
        }
        if (this.options.type) {
            valid = valid && (types.indexOf(this.options.type) > -1);
        }
        if (onlyComparable) {
            valid = valid && this.options.comparable;
        }
        this.setFiltered(!valid);
        this.div.toggleClass('highlighted', highlightTime && this.options.publication && (highlightTime < this.options.publication));
    };

    Marker.prototype.onClick = function() {
        if (this.options.url) {
            Navigation.push({
                url: this.options.url,
                title: this.options.title,
                noBack: true,
                marker: this.options.id
            });
            this.activate();
        }
    }

    Marker.prototype.onMouseEnter = function() {
        if (this.options.picture && !this.picture) this.picture = $(this.options.picture).appendTo(this.infobox);
        if (this.options.title && !this.title) this.title = $('<div class="title"/>').text(this.options.title).appendTo(this.infobox);
        if (this.options.year && !this.year) this.year = $('<div class="year"/>').text(this.options.year).appendTo(this.infobox);
    }

    Marker.prototype.onAdd = function () {
        this.getPanes().overlayMouseTarget.appendChild(this.div[0]);
    }

    Marker.prototype.animatePosition = function(newPosition, duration) {
        if (!duration) duration = 200;
        if (!(newPosition instanceof google.maps.LatLng)) newPosition = new google.maps.LatLng(newPosition.lat, newPosition.lng)

        const marker = this;
        const easing = function (x, t, b, c, d) {
            return b+(t/d)*c;
        }

        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

        // save current position. prefixed to avoid name collisions. separate for lat/lng to avoid calling lat()/lng() in every frame
        marker.startPosition_lat = marker.getPosition().lat();
        marker.startPosition_lng = marker.getPosition().lng();
        const newPosition_lat = newPosition.lat();
        const newPosition_lng = newPosition.lng();

        // crossing the 180° meridian and going the long way around the earth?
        if (Math.abs(newPosition_lng - marker.startPosition_lng) > 180) {
            if (newPosition_lng > marker.startPosition_lng) {
                newPosition_lng -= 360;
            } else {
                newPosition_lng += 360;
            }
        }

        const animateStep = function(marker, startTime) {
            const ellapsedTime = (new Date()).getTime() - startTime;
            const durationRatio = ellapsedTime / duration;
            const easingDurationRatio = easing(durationRatio, ellapsedTime, 0, 1, duration);

            if (durationRatio >= 1) return marker.setPosition(newPosition);

            marker.setPosition({
                lat: marker.startPosition_lat + (newPosition_lat - marker.startPosition_lat) * easingDurationRatio,
                lng: marker.startPosition_lng + (newPosition_lng - marker.startPosition_lng) * easingDurationRatio
            });

            if (requestAnimationFrame) {
                marker.animationHandler = requestAnimationFrame(() => animateStep(marker, startTime) );
            } else {
                marker.animationHandler = setTimeout(() => animateStep(marker, startTime), 17);
            }
        }

        // stop possibly running animation
        if (cancelAnimationFrame) cancelAnimationFrame(marker.animationHandler);
        else clearTimeout(marker.animationHandler);

        animateStep(marker, (new Date()).getTime());
    }

});
